import AuthWrapper from "../components/Layout/AuthWrapper";
import Login from "../components/Authentication/Login";
import Register from "../components/Authentication/Register";
import { isAuthenticated } from "../_services/authentication.service";

export default {
  path: "/authentication",
  component: AuthWrapper,
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: (to, from, next) => {
        if (isAuthenticated()) {
          next({ name: "administrator" });
        }
        next();
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      beforeEnter: (to, from, next) => {
        if (isAuthenticated()) {
          next({ name: "administrator" });
        }
        next();
      }
    }
  ]
};
